import { Reveal, Overline } from "./motion";
import { ROADMAP } from "./content";

export const Roadmap = () => (
  <section id="rota" className="relative bg-dm-sand py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-5 md:px-8">
      <div className="mb-16 max-w-2xl">
        <Reveal>
          <Overline color="#00D1FF">A rota de crescimento</Overline>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-display text-5xl font-black leading-[0.9] tracking-tighter text-dm-ink md:text-6xl lg:text-7xl">
            Quatro fases,
            <br />
            um plano vivo.
          </h2>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
        {ROADMAP.map((item, i) => (
          <Reveal key={item.phase} delay={i * 0.09}>
            <div className="group relative flex h-full flex-col overflow-hidden rounded-[2rem] border border-dm-ink/10 bg-white p-8 transition-shadow duration-500 hover:shadow-[0_24px_50px_rgba(0,0,0,0.08)]">
              <span className="text-xs font-bold uppercase tracking-[0.25em] text-dm-muted">
                {item.phase}
              </span>
              <span
                className="mt-4 font-display text-6xl font-black leading-none tracking-tighter"
                style={{ color: item.color }}
              >
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-6 font-display text-2xl font-bold tracking-tight text-dm-ink">
                {item.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-dm-muted">{item.desc}</p>
              <span
                className="mt-6 block h-1.5 w-full origin-left scale-x-0 rounded-full transition-transform duration-700 group-hover:scale-x-100"
                style={{ backgroundColor: item.color }}
              />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
